import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Layout from 'common/containers/Layout';
import { useOnMountDataRequest } from 'common/hooks';
import LoadingPage from 'common/components/LoadingPage';
import RewardsTabs from '../components/RewardsTabs';
import WithdrawalHistoryTable from '../components/WithdrawalHistoryTable';
import { actions, selectors } from '../index';

const HistoryPage = ({ withdrawals, isFetching }) => {
  useOnMountDataRequest(actions.withdrawalsRequest);

  return (
    <Layout heading="Rewards">
      <RewardsTabs />
      {isFetching ? (
        <LoadingPage />
      ) : (
        <WithdrawalHistoryTable withdrawals={withdrawals} />
      )}
    </Layout>
  );
};

HistoryPage.propTypes = {
  withdrawals: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),
  isFetching: PropTypes.bool.isRequired,
};

HistoryPage.defaultProps = {
  withdrawals: [],
};

export default connect((state) => ({
  withdrawals: selectors.withdrawalsData(state) || [],
  isFetching: selectors.isFetchingWithdrawals(state),
}))(HistoryPage);
